import React from 'react';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import RedTick from '../../images/redtick.svg'
import {RowWrapper, ColumnWrapper, ColumnTitle, DescWrapper, DescriptionText, Title, TitleWrapper} from './style'


const ColumnedCards = ({props}) => {


    const CardsRows = props.cards.map((data) => {
        return (
            <RowWrapper key={data[0].id}>
            <Row>
            {
                data.map((col)=> {
                    return(
                        <Col key={col.id}>
                            <ColumnWrapper>
                            <ColumnTitle bg_color={props.bg_color}>
                            {col.title_text}
                            </ColumnTitle>
                            <DescWrapper>
                            {col.description_text.map((data) => {
                                return (
                                <DescriptionText size={props.desc_font_size} key={data.id}>
                                    <img alt="RedTick" src={RedTick}></img>
                                    {data.text}
                                </DescriptionText>
                                )
                            })}
                            </DescWrapper>
                            </ColumnWrapper>
                        </Col>
                    )
                })
            }
            </Row>
            </RowWrapper>
        )
    })


    return (
        <>
        <TitleWrapper>
        <Title {...props}>
            {props.title_text}
        </Title>
        </TitleWrapper>
        <Container fluid>
            {CardsRows}
        </Container>
        </>
    )
}

export default ColumnedCards
